module.exports = __webpack_public_path__ + "img/altitude-room-3.e485c152.jpg";